import { checkResult } from "./checkResult";
export function createInitialState(size = 3, winLength = 3) {
    return {
        board: Array.from({ length: size }, () => Array(size).fill(null)),
        currentPlayer: "X",
        status: "play",
        winner: null,
        winLength,
    };
}
export function gameReducer(state, action) {
    switch (action.type) {
        case "MAKE_MOVE": {
            if (state.status !== "play")
                return state;
            if (state.board[action.cell.row][action.cell.col] !== null)
                return state;
            const newBoard = state.board.map((row, i) => i === action.cell.row
                ? row.map((cell, j) => j === action.cell.col ? state.currentPlayer : cell)
                : row);
            const result = checkResult({
                board: newBoard,
                winLength: state.winLength,
                lastMoveCell: action.cell,
            });
            return {
                ...state,
                ...result,
                board: newBoard,
                ...(result.status === "play"
                    ? { currentPlayer: state.currentPlayer === "X" ? "O" : "X" }
                    : { currentPlayer: null }),
            };
        }
        case "NEW_GAME":
            return createInitialState(action.size, action.winLength);
        default:
            return state;
    }
}
